import React from 'react'
import { CircularProgress, Box } from '@mui/material'

const LoadingFallback = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        width: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  )
}

export default LoadingFallback
